import { Button, Group, Modal, Text } from '@mantine/core';
import { CompanyDocument } from '../../types';

type ArchiveAppendixModalProps = {
  opened: boolean;
  onClose: () => void;
  document: CompanyDocument | null;
  onConfirm: () => Promise<void>;
  isLoading: boolean;
};

export default function ArchiveAppendixModal({
  opened,
  onClose,
  document,
  onConfirm,
  isLoading,
}: ArchiveAppendixModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} title="Archive appendix" centered>
      <Text mb="md">
        Are you sure you want to archive <strong>{document?.file.fileName}</strong>? It will no
        longer be available for selection in suitability reports.
      </Text>
      <Group justify="flex-end">
        <Button variant="subtle" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} loading={isLoading}>
          Archive
        </Button>
      </Group>
    </Modal>
  );
}
